import React from 'react'
import { Grid } from '@mui/material'
import LoginForm from '../LoginForm'
import SolutionsSection from '../SoluctionSection'
import { LoginType } from '../../types/login.types'

const LoginPage: React.FC<LoginType> = (props) => {
  return (
    <Grid
      container
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'column', lg: 'row' },
        alignItems: 'center'
      }}
    >
      <Grid xs={12} md={6} lg={6} item>
        <LoginForm {...props} />
      </Grid>
      <Grid xs={0} md={6} lg={6} item>
        <SolutionsSection />
      </Grid>
    </Grid>
  )
}

export default LoginPage
